import React from 'react';
import { Typography } from '@/UIlibrary/Typography/Typography';
import { SyncResult } from '../../CustomerSupport/types';

interface SyncStatsGridProps {
	syncResult: SyncResult;
	t: (key: string) => string;
}

const SyncStatsGrid: React.FC<SyncStatsGridProps> = ({ syncResult, t }) => {
	return (
		<>
			<div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
				<div className="p-4 bg-blue-50 rounded flex flex-col items-center justify-center">
					<Typography size="sm" color="secondary">
						{t('TotalProcessed')}
					</Typography>
					<Typography size="xl" weight="bold">
						{syncResult.total_processed}
					</Typography>
				</div>
				<div className="p-4 bg-green-50 rounded flex flex-col items-center justify-center">
					<Typography size="sm" color="secondary">
						{t('CustomersCreated')}
					</Typography>
					<Typography size="xl" weight="bold">
						{syncResult.customers_created}
					</Typography>
				</div>
				<div className="p-4 bg-yellow-50 rounded flex flex-col items-center justify-center">
					<Typography size="sm" color="secondary">
						{t('CustomersUpdated')}
					</Typography>
					<Typography size="xl" weight="bold">
						{syncResult.customers_updated}
					</Typography>
				</div>
				<div className="p-4 bg-purple-50 rounded flex flex-col items-center justify-center">
					<Typography size="sm" color="secondary">
						{t('ChatsCreated')}
					</Typography>
					<Typography size="xl" weight="bold">
						{syncResult.chats_created}
					</Typography>
				</div>
				<div className="p-4 bg-indigo-50 rounded flex flex-col items-center justify-center">
					<Typography size="sm" color="secondary">
						{t('ChatsUpdated')}
					</Typography>
					<Typography size="xl" weight="bold">
						{syncResult.chats_updated}
					</Typography>
				</div>
				<div className="p-4 bg-green-50 rounded flex flex-col items-center justify-center">
					<Typography size="sm" color="secondary">
						{t('TemplatesSent')}
					</Typography>
					<Typography size="xl" weight="bold">
						{syncResult.templates_sent}
					</Typography>
				</div>
				<div className="p-4 bg-red-50 rounded flex flex-col items-center justify-center">
					<Typography size="sm" color="secondary">
						{t('TemplatesFailed')}
					</Typography>
					<Typography size="xl" weight="bold">
						{syncResult.templates_failed}
					</Typography>
				</div>
				<div className="p-4 bg-gray-50 rounded flex flex-col items-center justify-center">
					<Typography size="sm" color="secondary">
						{t('TemplatesSkipped')}
					</Typography>
					<Typography size="xl" weight="bold">
						{syncResult.templates_skipped}
					</Typography>
				</div>
			</div>

			<div className="mb-4">
				<Typography size="sm" color="secondary">
					{t('ExecutionTime')}: {syncResult.execution_time_ms}ms
				</Typography>
			</div>
		</>
	);
};

export default SyncStatsGrid;
